import React, { forwardRef } from "react"

import { ReactComponent as AppleLogo } from "@common_assets/svg/apple-logo.svg"
import { Box, Button } from "@mui/material"
import SsoButtonContent from "components/common/ssoButtonContent"
import {
  ssoButtonVisualLayerSx,
  ssoOutlinedButtonSx,
} from "components/common/ssoButtonContent/ssoButton.styles"

interface IProps {
  text: string
  onClick?: () => void
}

type Ref = HTMLButtonElement

const AppleButton = forwardRef<Ref, IProps>(({ text, onClick }, ref) => {
  return (
    <Button
      ref={ref}
      onClick={onClick}
      variant="outlined"
      fullWidth
      sx={(theme) => ssoOutlinedButtonSx(theme)}
    >
      <Box sx={ssoButtonVisualLayerSx}>
        <SsoButtonContent
          icon={<AppleLogo />}
          iconSx={{ position: "relative", top: "-2px" }}
          text={text}
        />
      </Box>
    </Button>
  )
})

AppleButton.displayName = "AppleButton"

export default AppleButton
